// src/stores/insightStore.js
import { defineStore } from 'pinia'

export const useInsightStore = defineStore('insight', {
  state: () => ({
    insightData: {
      module: '',
      moduleClass: '',
      module_id: null,
      title: '',
      text: '',
      rounds: 1,
      use_reasoning: true,
      module_fields: {},
      moduleFields: {},
      selectedPersonas: [],
      agents: []
    },
    prompts: [],
    promptStatuses: {}
  }),

  actions: {
    setInsightData(data) {
      this.insightData = { ...this.insightData, ...data }
    },

    updatePrompts(prompts) {
      this.prompts = prompts
    },

    updatePromptStatus(promptId, status) {
      this.promptStatuses[promptId] = status
    },

    removePromptStatus(promptId) {
      delete this.promptStatuses[promptId]
    }
  },

  getters: {
    getPendingPrompts: (state) => {
      return Object.entries(state.promptStatuses)
        .filter(([_, status]) => status === 'processing' || status === 'pending')
        .map(([id]) => id)
    },

    hasDataForPromptCreation: (state) => {
      return state.insightData.title &&
             state.insightData.text &&
             state.insightData.moduleClass &&
             state.insightData.moduleFields[state.insightData.moduleClass]?.state &&
             state.insightData.moduleFields[state.insightData.moduleClass]?.city
    }
  }
})